"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublicEnv = getPublicEnv;
/**
 * Gets a list of environment variables that start with `NEXT_PUBLIC_`.
 */
function getPublicEnv() {
    const publicEnv = Object.keys(process.env)
        .filter((key) => /^NEXT_PUBLIC_/i.test(key))
        .reduce((env, key) => ({
        ...env,
        [key]: process.env[key],
    }), {});
    return publicEnv;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXB1YmxpYy1lbnYuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaGVscGVycy9nZXQtcHVibGljLWVudi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUtBLG9DQVlDO0FBZkQ7O0dBRUc7QUFDSCxTQUFnQixZQUFZO0lBQzFCLE1BQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQztTQUN2QyxNQUFNLENBQUMsQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztTQUMzQyxNQUFNLENBQ0wsQ0FBQyxHQUFHLEVBQUUsR0FBRyxFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBQ2IsR0FBRyxHQUFHO1FBQ04sQ0FBQyxHQUFHLENBQUMsRUFBRSxPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQztLQUN4QixDQUFDLEVBQ0YsRUFBZ0IsQ0FDakIsQ0FBQztJQUVKLE9BQU8sU0FBUyxDQUFDO0FBQ25CLENBQUMifQ==